import { Component, OnInit, Inject, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { QnSbnService } from '../../../services/qn-sbn-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import { QnSbnDataServiceService } from '../../../services/qn-sbn-data-service.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { OneWebComponentsAngularModule } from '@one/angular';

@Component({
  selector: 'dl-add-note',
  standalone: true,
  imports: [OneWebComponentsAngularModule, FormsModule, ReactiveFormsModule],
  templateUrl: './add-note.component.html',
  styleUrls: ['./add-note.component.scss']
})
export class AddNoteComponent implements OnInit {
  @Input() data: any;
  @Output() noteAdded = new EventEmitter<any>();
  public addNoteFC = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);
  public internalNote: any;
  public isEditForm: boolean = false;
  constructor(
    private snackBarNotification: SnackbarService,
    private qnsbnservice: QnSbnService,

  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue?.tableData?.notificationData?.NoteText) {
      this.internalNote = this.data.tableData.notificationData.NoteText;
      this.addNoteFC.setValue(this.internalNote);
      this.isEditForm = true;
    }
  }


  ngOnInit(): void {

  }

  public saveNote() {
    let noteData = {};
    let responseMessage = '';
    let noteText = this.addNoteFC.value;
    if (noteText.length > 500) {
      this.snackBarNotification.snackBarMessage('alarm', 'Note is too long. Maximum length is 500 characters');
    } else if(noteText.length < 5){
      this.snackBarNotification.snackBarMessage('alarm', 'Note is too short. Minimum length is 5 characters');
    }else {
      noteData = {
        "NoteType": "Notification",
        "NoteText": this.addNoteFC.value,
        "NotificationId": this.data.tableData.notificationData.NotificationId || "",
        "userId": this.data.tableData.notificationData.UserId || "",
        "userRole": this.data.tableData.notificationData.UserRole || ""
      }
      if (this.isEditForm) {
        responseMessage = "Note updated successfully";
      } else {
        responseMessage = "Note added successfully";
      }

      this.qnsbnservice.saveInternalNote(noteData).subscribe(
        (responseData: any) => {
          console.log("note save response",responseData);
          
          if (responseData.$metadata?.httpStatusCode === 200) {
            this.snackBarNotification.snackBarMessage('positive', responseMessage);
            this.data.tableData.notificationData.NoteText = this.addNoteFC.value;
            this.noteAdded.emit(this.addNoteFC.value);
          }
        },
        (error: HttpErrorResponse) => {
          this.qnsbnservice.httpErrorHandler(error, 'Could not save Note.');
         // this.snackBarNotification.snackBarMessage('alarm', error.error);
        }
      );
    }
  }

  cancelClicked() {
    this.noteAdded.emit(null);

}
}
